define('SageDotCom/DataLayer/Global/slider',['jquery',
        'SageDotCom/DataLayer/tealium',
        'SageDotCom/DataLayer/Events/carouselCustomerStory',
        'SageDotCom/DataLayer/Events/carouselGeneric',
        'SageDotCom/DataLayer/Events/carouselHero',
        'SageDotCom/DataLayer/Util/trackingHelper',
        'SageDotCom/DataLayer/Util/htmlHelper',
        'slick'],
    function ($, tealium, customerStory, generic, hero, trackingHelper, htmlHelper) {
        function globalSliderTracking() { }

        function deriveControl(e) {
            var control = '(not set)';

            if (e.currentTarget.className.indexOf('carousel-control') !== -1) {
                var direction = e.currentTarget.className.indexOf('right') !== -1 ? 'right' : 'left';
                control = "Arrow: " + direction;
            } else {
                var slide = $(e.currentTarget).attr('data-slide-to');
                control = "Slide: " + slide;
            }

            return control;
        }

        function getEventType(carousel) {
            if ($(".hero--customer-quote", carousel).length > 0) {
                // customer success carousel
                return customerStory;
            } else if ($("h1, .score-hero", carousel).length > 0) {
                // hero carousel
                return hero;
            }

            // normal carousel
            return generic;
        }

        globalSliderTracking.prototype.initialize = function initialize() {
            $(".slick-slider:not([data-xpr-state], [data-tracking])").each(function(key, slider) {
                var event = getEventType(slider);

                $(slider).on('swipe', function (e, slick, direction) {
                    // invert the direction as we want to know the direction the user is swiping to, not the direction
                    // that the panes are moving in
                    var label = direction === "left" ? "right" : "left"; 

                    var currentSlide = $("[data-slick-index='" + slick.currentSlide + "']", slider);
                    var menu = htmlHelper.findTitle(currentSlide);

                    var eventObj = event.GenerateEventMetadata(slider, label, menu);
                    tealium.event(eventObj);
                });

                $(".slick-arrow", slider).on('click', function (e) {
                    // invert the direction as we want to know the direction the user is swiping to, not the direction
                    // that the panes are moving in
                    var label = $(e.currentTarget).hasClass('slick-next') ? "right" : "left";

                    var currentSlideIndex = $(slider).slick('slickCurrentSlide');
                    var currentSlide = $("[data-slick-index='" + currentSlideIndex + "']", slider);
                    var menu = htmlHelper.findTitle(currentSlide);
                
                    var eventObj = event.GenerateEventMetadata(slider, label, menu);
                    tealium.event(eventObj);
                });
                
                $(".slick-dots li", slider).on('click', function (e) {
                    var label = "select";

                    var currentSlideIndex = $(slider).slick('slickCurrentSlide');
                    var currentSlide = $("[data-slick-index='" + currentSlideIndex + "']", slider);
                    var menu = htmlHelper.findTitle(currentSlide);
                
                    var eventObj = event.GenerateEventMetadata(slider, label, menu);
                    tealium.event(eventObj);
                });

                trackingHelper.registerTracking(slider, event.getName());
            });
        }

        return new globalSliderTracking();
    });
